import React, { useEffect, useMemo, useState } from "react";
import { Table, Input, Button, Popconfirm, message } from "antd";
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import deleteItem from "../../../hooks/admin/deleteItem";
import getAllAdmin from "../../../hooks/getAllAdmin";
import { DeleteOutlined } from "@mui/icons-material";

const AllPlans = () => {
  const { t } = useTranslation();
  const [plans, setPlans] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    const getAllPlans = async () => {
      const res = await getAllAdmin("admin/getallplan");

      if (res.status_code === 200) {
        setPlans(res.data);
      }
    };
    getAllPlans();
  }, []);

  const handleDelete = async (id) => {
    const updated = await deleteItem(
      id,
      plans,
      setPlans,
      plans.filter((item) =>
        item.plan_name.toLowerCase().includes(filterText.toLowerCase())
      ),
      "plan_id",
      "admin/deleteplan"
    );
    if (updated) message.success(t("Deleted_successfully"));
    else message.error(t("Delete_failed"));
  };

  const filteredPlans = useMemo(() => {
    return plans.filter((item) =>
      item.plan_name.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [plans, filterText]);

  const columns = [
    {
      title: t("Name"),
      dataIndex: "plan_name",
      key: "plan_name",
    },
    {
      title: t("Price"),
      dataIndex: "plan_price",
      key: "plan_price",
    },
    {
      title: t("Product_Limit"),
      dataIndex: "product_limit",
      key: "product_limit",
    },
    {
      title: t("Validity"),
      dataIndex: "no_of_days",
      key: "no_of_days",
      render: (days) => `${days} ${t("Days")}`,
    },
    {
      title: t("Options"),
      key: "action",
      render: (_, record) => (
        <div className="flex gap-2">
          <Link
            to={`/admin/plan/edit/${record.plan_id}`}
            title={t("Edit")}
            className="p-2 flex items-center border border-green-500 hover:bg-green-500 rounded-full text-green-500 hover:text-white cursor-pointer duration-300"
          >
            <AiTwotoneEdit />
          </Link>
          <span
            onClick={() =>
              deleteItem(
                record.plan_id,
                plans,
                setPlans,
                filteredPlans,
                "plan_id",
                "admin/deleteplan"
              )
            }
          >
            <Button danger icon={<DeleteOutlined />} />
          </span>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg md:text-2xl font-semibold">{t("All_Plans")}</h2>
        <Link to="/admin/plan/create">
          <button className="btn btn-primary btn-sm text-white">{t("Create_New_Plan")}</button>
        </Link>
      </div>

      <div className="mb-4 flex flex-wrap gap-2">
        <Input
          placeholder={t("Search_by_name")}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{ width: 250 }}
        />
        <Button onClick={() => setFilterText("")}>{t("Clear")}</Button>
      </div>

      <Table
        rowKey="plan_id"
        columns={columns}
        dataSource={filteredPlans}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </>
  );
};

export default AllPlans;

